import React, { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const PolicyholderDetails = lazy(
  () => import('@pages/landing/PolicyholderDetails'),
);

export const PolicyholderDetailsRoutes: RouteObject[] = [
  {
    path: '/policyholder-details',
    element: (
      <React.Suspense>
        <PolicyholderDetails />
      </React.Suspense>
    ),
  },
];